export default __webpack_public_path__ + "static/media/Sharad_Verma.fb08569e.png";